<template>
    <div>
        <sched-termbuilder />
        <p>
            モード:
            <label><input name="preferred" type="radio" value="preferred" v-model="editMode">希望入力</label>
            <label><input name="assigned" type="radio" value="assigned" v-model="editMode">実配置</label>
        </p>
        <sched-matrix :people="people" :days="days" :edit-mode="editMode" />
    </div>
</template>


<script>
import Firebase from 'firebase';
import Matrix from './Matrix.vue';
import TermBuilder from './TermBuilder.vue';

export default {
    data() {
        return {
            people: [],
            peopleMap: {},
            days: [],
            editMode: "preferred",
            status: null,
        }
    },
    created() {
        let db = Firebase.database()

        db.ref('people').on('value', (snapshot) => {
            let people = [];
            this.peopleMap = {};
            snapshot.forEach((child) => {
                let x = child.val();
                x.key = child.key;
                this.peopleMap[child.key] = x;
                people.push(x);
            });
            this.people = people;
            this.recalcSum();
        });
        db.ref('days').on('value', (snapshot) => {
            this.days = [];
            snapshot.forEach((child) => {
                let d = child.val();
                d.weekday = (new Date(d.year, d.month - 1, d.day)).getDay();
                d.key = child.key;
                this.days.push(d);
            });
            this.recalcSum();
        });
    },
    destroyed() {
        Firebase.database().ref('people').off('value');
        Firebase.database().ref('days').off('value');
    },
    methods: {
        recalcSum() {
            console.log("recalc")
            let sumPeople = {
                total: 0, reporter: 0, editor: 0,
            };
            this.people.forEach((p) => {
                sumPeople.total++;
                if (p && p.isEditor) { sumPeople.editor++; }
                if (p && p.isReporter) { sumPeople.reporter++; }
                p.sumAbsent = 0;
            })

            this.days.forEach((d) => {
                d.sumPeople = sumPeople;

                let sum = {
                    total: 0, reporter: 0, editor: 0,
                };
                Object.keys(d.preferred || {}).forEach((pk) => {
                    let p = this.peopleMap[pk];
                    if (p) {
                        let s = d.preferred[pk] || null;
                        if (s == 'A' || s == 'a') {
                            sum.total++;
                            if (p && p.isEditor) { sum.editor++; }
                            if (p && p.isReporter) { sum.reporter++; }
                        }
                    }
                })
                d.sumRequiredAbsence = sum;

                sum = {
                    total: 0, reporter: 0, editor: 0,
                };
                Object.keys(d.assigned || {}).forEach((pk) => {
                    let p = this.peopleMap[pk];
                    if (p) {
                        let s = d.assigned[pk];
                        if (s == 'A' || s == 'a') {
                            sum.total++;
                            if (p && p.isEditor) { sum.editor++; }
                            if (p && p.isReporter) { sum.reporter++; }
                            p.sumAbsent += 1;
                        }
                    }
                })
                d.sumAssignedAbsence = sum;
            });
        },
    },
    components: {
        'sched-matrix': Matrix,
        'sched-termbuilder': TermBuilder,
    }
}
</script>


<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/Main.vue